import * as yup from 'yup';

export const deviceFormSchema = (validateEan: boolean) =>
  yup.object().shape({
    invoiceSeries: yup
      .string()
      .required('Série obrigatória.')
      .matches(/^\d+$/, 'Apenas números.')
      .matches(/^\d{3}$/, 'Deve conter 3 números.')
      .typeError('Série inválida.'),

    invoiceNumber: yup
      .string()
      .required('Número da NF obrigatório.')
      .matches(/^\d+$/, 'Apenas números.')
      .matches(/^\d{9}$/, 'Deve conter 9 números.')
      .typeError('Número inválido.'),

    imei: yup
      .string()
      .required('IMEI obrigatório.')
      .matches(/^35/, 'Deve iniciar com 35.')
      .matches(/^\d+$/, 'Apenas números.')
      .matches(/^\d{15}$/, 'Deve conter 15 números.')
      .typeError('IMEI inválido.'),

    ean: validateEan
      ? yup
          .string()
          .optional()
          .transform((value) => (value === '' ? undefined : value))
          .matches(/^\d+$/, 'Apenas números.')
          .matches(/^[1-9]/, 'Não pode iniciar com 0.')
          .matches(/^\d{13}$/, 'Deve conter 13 números.')
      : yup.mixed().strip(),
  });
